import { makeStyles } from "@material-ui/core";
import { format } from "date-fns";
import {
  getDateTimeLocale,
  getDateTimeFormats,
} from "../../../../../../utils/get-date-time-locale";
import { useTranslation } from "react-i18next";

import React, { useMemo } from "react";
import {
  Action,
  Comment,
  Header,
  Info,
  InfoContainer,
  InitialCommentInfoContainer,
  InitialRegisterTitle,
  ReviewsContainer,
} from "./styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
  },
  button: {
    ...theme.typography.subtitle1,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    minWidth: 180,
    minHeight: 50,
    borderRadius: 25,
    marginTop: "5vh",
  },
  spacer: {
    marginBottom: 20,
  },
  success: {
    backgroundColor: theme.palette.success.dark,
    borderRadius: 5,
    height: 50,
  },
  label: {
    ...theme.typography.subtitle1,
    color: theme.palette.primary.contrastText,
  },
  icon: {
    color: theme.palette.primary.contrastText,
    fontSize: 30,
    marginRight: 50,
  },
  titleModal: {
    color: "#031795",
    fontWeight: "bold",
    fontSize: "20px",
  },
}));

const ReviewsModal = ({ setModalStatus, t, generalComment }) => {
  const classes = useStyles();
  const { i18n } = useTranslation();

  const formattedGeneralComments = useMemo(() => {
    const saoPauloOffset = -3 * 60; // Sao Paulo is UTC-3

    let createdDateInBrazilianTimezone = undefined;

    if (generalComment.createDate_GeneralComments) {
      const utcDate = new Date(generalComment.createDate_GeneralComments);
      createdDateInBrazilianTimezone = new Date(
        utcDate.getTime() + saoPauloOffset * 60 * 1000
      );
    }

    let changedDateInBrazilianTimezone = undefined;

    if (generalComment.changeDate_GeneralComments) {
      const utcDate = new Date(generalComment.changeDate_GeneralComments);
      changedDateInBrazilianTimezone = new Date(
        utcDate.getTime() + saoPauloOffset * 60 * 1000
      );
    }

    if (generalComment?.generalCommentsHistoric.length < 0) {
      return {
        initialValue: {
          createdAt: new Date(generalComment.createDate_GeneralComments),
          comment: generalComment.description_GeneralComments,
        },
        generalCommentsHistoric: [],
      };
    }

    const lastReviewItem = {
      iD_GeneralComments: generalComment.iD_GeneralComments,
      idMinuteSlot_GeneralComments: generalComment.idMinuteSlot_GeneralComments,
      requesterReviewer_GeneralComments:
        generalComment.requesterReviewer_GeneralComments,
      reviewer_GeneralComments: generalComment.reviewer_GeneralComments,
      description_GeneralComments: generalComment.description_GeneralComments,
      createDate_GeneralComments: new Date(
        generalComment.createDate_GeneralComments
      ),
      changeDate_GeneralComments: new Date(
        generalComment.changeDate_GeneralComments
      ),
      enable_GeneralComments: generalComment.enable_GeneralComments,
    };

    const newHistory = generalComment?.generalCommentsHistoric.filter(
      (item) =>
        item.iD_GeneralComments !==
        generalComment?.generalCommentsHistoric[
          generalComment.generalCommentsHistoric.length - 1
        ].iD_GeneralComments
    );

    newHistory.push(lastReviewItem);

    let currentCommentCreatedDateInBrazilianTimezone = undefined;

    if (
      generalComment?.generalCommentsHistoric[
        generalComment.generalCommentsHistoric.length - 1
      ].createDate_GeneralComments
    ) {
      const utcDate = new Date(
        generalComment?.generalCommentsHistoric[
          generalComment.generalCommentsHistoric.length - 1
        ].createDate_GeneralComments
      );
      currentCommentCreatedDateInBrazilianTimezone = new Date(
        utcDate.getTime() + saoPauloOffset * 60 * 1000
      );
    }

    return {
      initialValue: {
        createdAt: currentCommentCreatedDateInBrazilianTimezone,
        comment:
          generalComment?.generalCommentsHistoric[
            generalComment.generalCommentsHistoric.length - 1
          ].description_GeneralComments,
      },
      generalCommentsHistoric: newHistory.sort(
        (a, b) =>
          new Date(a.createDate_GeneralComments) -
          new Date(b.createDate_GeneralComments)
      ),
    };
  }, [generalComment]);

  return (
    <div>
      <Header>
        <span
          style={{ float: "right", cursor: "pointer" }}
          onClick={() => {
            setModalStatus(false);
          }}
        >
          [X] Fechar
        </span>
        <span className={classes.titleModal}>{t(`menu.minutes.reviews`)}</span>
      </Header>

      <ReviewsContainer>
        <Action>
          <Comment>
            <InitialRegisterTitle>
              {t("forms.minutes.actions.initialRegister")}
            </InitialRegisterTitle>

            <InitialCommentInfoContainer>
              <Info>
                <span>{t("forms.minutes.actions.createdDate")}:</span>
                <span>
                  {format(
                    new Date(formattedGeneralComments.initialValue.createdAt),
                    getDateTimeFormats(i18n.language),
                    { locale: getDateTimeLocale(i18n.language) }
                  )}
                </span>
              </Info>
              <Info>
                <span>{t("forms.minutes.actions.generalComments")}</span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: formattedGeneralComments.initialValue.comment,
                  }}
                />
              </Info>
            </InitialCommentInfoContainer>
          </Comment>

          {formattedGeneralComments?.generalCommentsHistoric?.map((review) => (
            <Comment>
              <InitialRegisterTitle>Revisão:</InitialRegisterTitle>

              <InfoContainer>
                <Info>
                  <span>Data da revisão:</span>
                  <span>
                    {format(
                      new Date(review.createDate_GeneralComments),
                      getDateTimeFormats(i18n.language),
                      { locale: getDateTimeLocale(i18n.language) }
                    )}
                  </span>
                </Info>

                <Info>
                  <span>{t("forms.minutes.actions.reviewerRequester")}</span>
                  <span>{review.requesterReviewer_GeneralComments}</span>
                </Info>

                <Info>
                  <span>{t("forms.minutes.actions.reviewer")}</span>
                  <span>{review.reviewer_GeneralComments}</span>
                </Info>
              </InfoContainer>

              <Info>
                <span>{t("forms.minutes.actions.generalComments")}</span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: review.description_GeneralComments,
                  }}
                />
              </Info>
            </Comment>
          ))}
        </Action>
      </ReviewsContainer>
    </div>
  );
};

export default ReviewsModal;
